
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var SealApplyPage = Vue.extend({})
Vue.component('sealApply-page', SealApplyPage)

export default {
  name: 'SealApplyPage',
  components: {
    XTable
  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: ''
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/sealApply.vue